import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { registerLocale } from 'react-datepicker';

import LanguageDetector from 'i18next-browser-languagedetector';
import datePtBr from 'date-fns/locale/pt-BR'; // the locale you want

import 'moment/locale/pt-br';

import en from './en';
import ptBr from './pt-br';
import es from './es';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'ptBr',
    resources: { en, ptBr, es },
    keySeparator: '.',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

registerLocale('pt-BR', datePtBr);

window.i18n = i18n;

export default i18n;
